var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPayroll = function SvgPayroll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.333 4H7.666a1 1 0 0 0 0 2h.667a1 1 0 0 1 0 2H6.666M8 3.333V4m0 4v.667M12 6h.006M4 6h.006M1.333 3.467v5.066c0 .747 0 1.12.145 1.406.128.25.332.454.583.582.285.146.659.146 1.405.146h9.067c.747 0 1.12 0 1.405-.146.251-.128.455-.332.583-.582.145-.286.145-.659.145-1.406V3.467c0-.747 0-1.12-.145-1.406a1.333 1.333 0 0 0-.583-.582c-.285-.146-.658-.146-1.405-.146H3.466c-.746 0-1.12 0-1.405.146-.25.127-.455.331-.583.582-.145.286-.145.659-.145 1.406Zm11 2.533a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Zm-8 0a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
  })));
};
export default SvgPayroll;